import { News } from '@/types/news';
import RootStore from '.';
import BaseStore from './BaseStore';
import { NewsApi } from '@/apis';
import { GetNewsRequest, GetNewsResponse, PostNewsRequest } from '@/types/http-payload/news';
import { TableState } from '@tanstack/react-table';
import { ResponseData } from '@/types/http';
import { flow, makeObservable, observable } from 'mobx';

export default class NewsStore extends BaseStore {
    news: News[] = [];
    newHomes: News[] = [];
    api: NewsApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            news: observable,
            newHomes: observable,
            getNews: flow.bound,
            getNewsForEnduser: flow.bound,
            getNewsDetailForEnduser: flow.bound,
            createNews: flow.bound,
            getNewsById: flow.bound,
            updateNews: flow.bound,
            deleteNews: flow.bound,
            getNewHomes: flow.bound
        });
        this.api = new NewsApi();
    }

    // #region CMS
    *getNews(request: GetNewsRequest, paging?: TableState) {
        try {
            const payload = { ...this.convertPagingFromTableToRequest(paging ?? this.paging), ...request };
            const res: ResponseData<GetNewsResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getNews, payload);
            if (res.ok) {
                this.news = res.data.elements;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.paginate)
                };
                this.totalRecord = res.data.paginate.totalRecord;
            }
        } catch (error) {
        }
    }

    *createNews(payload: PostNewsRequest) {
        try {
            const res: ResponseData<News> = yield this.rootStore.apiStore.call(this.api, this.api.createNews, payload);
            if (res.ok) {
                return res.data;
            }
        } catch (error) {
        }
    }

    *getNewsById(newsId: number) {
        try {
            const res: ResponseData<News> = yield this.rootStore.apiStore.call(this.api, this.api.getNewsId, newsId);
            if (res.ok) {
                return res.data;
            }
        } catch (error) {
        }
    }

    *updateNews(newsId: number, payload: PostNewsRequest) {
        try {
            const res: ResponseData<News> = yield this.rootStore.apiStore.call(this.api, this.api.updateNews, { newsId, payload });
            if (res.ok) {
                return res.data;
            }
        } catch (error) {
        }
    }

    *deleteNews(newsId: number) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.deleteNews, newsId);
            if (res.ok) {
                return res;
            }
        } catch (error) {
        }
    }

    // #endregion

    // #region End User
    *getNewsForEnduser(request: GetNewsRequest, paging?: TableState) {
        try {
            const payload = { ...this.convertPagingFromTableToRequest(paging ?? this.paging), ...request };
            const res: ResponseData<GetNewsResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getNewsForEnduser, payload);
            if (res.ok) {
                this.news = res.data.elements;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.paginate)
                };
                this.totalRecord = res.data.paginate.totalRecord;
                return res.data.elements;
            }
        } catch (error) {
        }
    }

    *getNewsDetailForEnduser(newsId: string, request: GetNewsRequest) {
        try {
            const res: ResponseData<News> = yield this.rootStore.apiStore.call(this.api, this.api.getNewsDetailForEnduser, { id: newsId, payload: request });
            if (res.ok) {
                return res.data;
            }
        } catch (error) {
        }
    }

    *getNewHomes(payload) {
        try {
            const res: ResponseData<GetNewsResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getNewHomes, payload);
            if (res.ok) {
                this.newHomes = res.data.elements;
                return res.data;
            }
            return false;
        } catch (error) {
        }
    }
    // #endregion

    clean(): void {
        super.clean();
        this.news = [];
        this.newHomes = [];
    }
}
